import { useEffect, useRef, useState, useCallback } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { API, useAuth } from '../contexts/AuthContext';
import { TEMPO_DE_POLL_MS } from '../helpers/rede';

// Disponibilidade do atendente: bate o heartbeat enquanto o app está aberto e
// expõe o status (disponivel/ausente/offline) + o toggle Ausente. Só roda pra
// quem atende (ti:atendimentos). Bate a cada 30s e quando a aba volta ao foco.
export default function usePresenca() {
  const { user, temPermissao } = useAuth();
  const podeAtender = temPermissao('ti:atendimentos');
  const [status, setStatus] = useState('offline');
  const [ausente, setAusente] = useState(false);
  const timerRef = useRef(null);
  const emVooRef = useRef(false);

  const aplicar = (d) => { if (d) { setStatus(d.status); setAusente(!!d.ausente); } };

  // Tempo limite e sem empilhar (ver helpers/rede). SEM pausar com a tela
  // escondida, de propósito: se o pulso parar, o servidor pode achar que a
  // pessoa saiu e parar de mandar conversa pra ela.
  const bater = useCallback(async () => {
    if (emVooRef.current) return;
    emVooRef.current = true;
    try { aplicar((await axios.post(`${API}/atendimentos/presenca/heartbeat`, null, { timeout: TEMPO_DE_POLL_MS })).data?.data); }
    catch (_) { /* rede caiu — segue offline até voltar */ }
    finally { emVooRef.current = false; }
  }, []);

  useEffect(() => {
    if (!user || !podeAtender) return undefined;
    bater();
    timerRef.current = setInterval(bater, 30000);
    const aoVoltar = () => { if (!document.hidden) bater(); };
    window.addEventListener('focus', aoVoltar);
    document.addEventListener('visibilitychange', aoVoltar);
    return () => {
      clearInterval(timerRef.current);
      window.removeEventListener('focus', aoVoltar);
      document.removeEventListener('visibilitychange', aoVoltar);
    };
  }, [user, podeAtender, bater]);

  // Pergunta antes de trocar (pedido do Lucas, 24/09/2026): o botão fica no
  // topo da tela, encosta-se nele sem querer no tablet, e a troca muda quem
  // recebe conversa — sem barreira nenhuma o atendente saía do sorteio sem
  // perceber e as conversas ficavam paradas no Pendente.
  //
  // O texto diz o que MUDA de fato: Ausente tira do sorteio da distribuição
  // automática e do auto-puxar; Disponível devolve as duas coisas.
  const toggleAusente = useCallback(async () => {
    const indoPraAusente = !ausente;
    const r = await Swal.fire({
      title: indoPraAusente ? 'Entrar em Ausente?' : 'Voltar a ficar Disponível?',
      text: indoPraAusente
        ? 'Você para de receber conversa nova automaticamente e o Fio não te entrega os pendentes. As conversas que já são suas continuam com você.'
        : 'Você volta a receber conversa nova automaticamente, e os pendentes parados da sua fila podem cair pra você agora.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: indoPraAusente ? 'Ficar Ausente' : 'Ficar Disponível',
      cancelButtonText: 'Cancelar',
      confirmButtonColor: indoPraAusente ? '#f5a623' : '#3D8B37',
    });
    if (!r.isConfirmed) return;
    try { aplicar((await axios.put(`${API}/atendimentos/presenca/ausente`, { ausente: indoPraAusente })).data?.data); }
    catch (_) { /* silencioso */ }
  }, [ausente]);

  return { status, ausente, podeAtender, toggleAusente };
}
